import { createStorage } from '../lib/storage'
import { RoomLastMessage } from '$logic/room-last-message/types'

export const [roomLastMessageStorage, roomLastMessageReducer] =
  createStorage<RoomLastMessage>('roomLastMessage')

class TemporaryLastMessageStorage {
  private lastMessages = new Map<string, RoomLastMessage>()

  get(roomId: string) {
    return this.lastMessages.get(roomId)
  }

  set(roomId: string, lastMessage: RoomLastMessage) {
    this.lastMessages.set(roomId, lastMessage)
  }

  delete(roomId: string) {
    this.lastMessages.delete(roomId)
  }
}

export const temporaryLastMessageStorage = new TemporaryLastMessageStorage()
